var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoverSkill3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 93,
    viewBox: "0 0 304 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304 33.8L293.867 35.3403C283.733 36.9969 263.467 39.9031 243.2 44.6403C222.933 49.2031 202.667 55.5969 182.4 50.8597C162.133 46.2969 141.867 30.6031 121.6 27.6097C101.333 24.5 81.0667 33.8 60.8 43.1C40.5333 52.4 20.2667 61.7 10.1333 66.35L3.33786e-06 71V-22H10.1333C20.2667 -22 40.5333 -22 60.8 -22C81.0667 -22 101.333 -22 121.6 -22C141.867 -22 162.133 -22 182.4 -22C202.667 -22 222.933 -22 243.2 -22C263.467 -22 283.733 -22 293.867 -22H304V33.8Z",
    fill: "#DB65A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 93,
    fill: "white",
    transform: "translate(304 93) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverSkill3);
export default __webpack_public_path__ + "static/media/cover_skill3.ec741840a033ecc7faf6306910fb54c2.svg";
export { ForwardRef as ReactComponent };